import gql from "graphql-tag";

export const DELETE_ROLE_QUERY = gql`
  mutation DeleteRoleMutation($name: String!) {
    deleteRole(where: { name: $name }) {
      name
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mutations/DeleteRole/queries.ts